import RelendLogo from "@/assets/icons/relend-light.svg"
import DogCuteSuccess from "@/assets/images/dog-cute-confirm.png"
import Button from "@/components/base/Button"
import { HelperText } from "@/utils/dataTypes"
import { Box, Typography } from "@mui/material"
import Image from "next/image"
import { FC } from "react"

type ModalTxConfirm = {
  title: string
  description: string
  textConfirm: string
  helperText: HelperText
  loading: boolean
  handleConfirm: () => void
}

const View: FC<ModalTxConfirm> = ({ title, description, textConfirm, helperText, loading, handleConfirm }) => {
  return (
    <Box className='relative flex flex-col items-center gap-4'>
      <Image
        className='absolute top-0 right-0 z-0 sm:h-52 sm:w-52'
        src={RelendLogo}
        alt='relend'
        width={225}
        height={255}
      />
      <Image src={DogCuteSuccess} alt='hero-stat-icon' className='z-10' height={128} style={{ marginBottom: 16 }} />
      <Typography className='z-10 text-center sm:text-2xl font-bold'>{title}</Typography>
      <Typography className='z-10 text-center sm:text-base text-neutral-900'>{description}</Typography>
      {helperText.content ? (
        <Typography className='mb-2 text-center w-full' sx={{ color: helperText.color }}>
          {helperText.content}
        </Typography>
      ) : null}
      <Box className='z-10 w-full'>
        <Button variant='primary' onClick={handleConfirm} size='lg' fullWidth loading={loading}>
          {textConfirm}
        </Button>
      </Box>
    </Box>
  )
}

export default View
